module.exports = __webpack_public_path__ + "static/media/two.da442a01.jpeg";